<div class="p-12">
  <button mat-raised-button color="accent"
    *ngIf="(role.toLowerCase() === 'petitioner') || (role.toLowerCase() === 'heir')" aria-label="Add task"
    (click)="addAlert()">
    <mat-icon style="color : white ; margin-top : -3px">add</mat-icon>
    ADD
  </button>

  <div class="mat-elevation-z8">
    <mat-table [dataSource]="openAlerts">
      <ng-container matColumnDef="subject">
        <mat-header-cell *matHeaderCellDef> Subject </mat-header-cell>
        <mat-cell *matCellDef="let element" style="text-transform: capitalize;"> 
          <button mat-button color="accent" (click)="openAlert(element.id)">
            {{ element.subject }} 
            <span *ngIf="!isRead(element.id)" class="error">!</span>
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="created_date">
        <mat-header-cell *matHeaderCellDef> Creation Date </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.created_date | date }} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="modifiedDate">
        <mat-header-cell *matHeaderCellDef>Modified Date</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{modifyDate(element.id) | date}} </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>

</div>

<!-- <div style = "padding : 100px">
  <button *ngIf = "role !== 'CLERK' && role !== 'JUDGE' " mat-fab class=" mat-warn" aria-label="Add task"  (click)="addAlert()"
          tooltip = "ADD ALERT"     style = "position: absolute; right: 14px ; top: 9px; width:50px ; height : 50px ; z-index : 6 ">
    <mat-icon class = "add" style = "color : white ; margin-top : -3px" >add</mat-icon>
  </button>
   -->

<!-- </div> -->



// WEBPACK FOOTER //
// ./src/app/main/content/common/alertList/alertList.component.html